package com.merkost.handpass.admin.di

import com.merkost.handpass.admin.api.AdminRepositoryApi
import com.merkost.handpass.admin.api.AdminRepositoryImpl
import com.merkost.handpass.admin.api.MockAdminRepository
import com.merkost.handpass.admin.platform.WindowFocusTrigger
import com.merkost.handpass.admin.util.isDevPreview
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

val repositoryModule = module {
    single<AdminRepositoryApi> { if (isDevPreview()) MockAdminRepository() else AdminRepositoryImpl() }
    singleOf(::WindowFocusTrigger)
}
